import MainLayout from 'layouts/MainLayout';

import LoginPage from 'pages/Login';
import SignupPage from 'pages/Signup';

const routes =  [{
    layout: MainLayout,
    routes: [{
        path: '/user/login',
        element: LoginPage,
        exact: true,
        analytics: { name: ["Login"] },
    }, {
        path: '/user/signup',
        element: SignupPage,
        exact: true,
        analytics: { name: ["Signup"] },
    }]
}]

export default routes;